<template>
  <div class="secur-ity m-consumption fater">
    <div class="u-toptilte">
      <p>
        <i style="color: #ffcc00">▎</i>修改密码
      </p>
    </div>
    <div>
      <!-- 手机号 -->
      <div class="form">
        <el-form label-width="120px" :label-position="mobile_flag ? 'top' : 'right'">
          <el-row>
            <el-col>
              <el-form-item label="手机号码：">
                <el-input placeholder="请输入您的手机号" @blur="phonea" v-model="shuru.phone"></el-input>
                <div class="el-form-item__error">{{ cuowuspan.phone }}</div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row type="flex" align="bottom">
            <el-col :span="14">
              <el-form-item label="验证码：">
                <el-input placeholder="请输入六位验证码" @blur="Verificationa" v-model="shuru.Verification"></el-input>
                <div class="el-form-item__error">{{ cuowuspan.Verification }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <el-form-item></el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item>
                <el-button
                  type="warning"
                  round
                  :disabled="disabled || shuru.phone.length != 11"
                  @click="send"
                  class="yzmnew"
                  :style="
                    shuru.phone.length === 11
                      ? 'background: linear-gradient(90deg, #f3c304 0%, #ffe682 100%); border-radius: 5px; color: black;'
                      : ''
                  "
                >{{ sends }}</el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="新密码：">
                <el-input
                  placeholder="请输入您的密码"
                  @blur="passa"
                  v-model="shuru.pass"
                  show-password
                  maxlength="25"
                  minlength="8"
                ></el-input>
                <div class="el-form-item__error">{{ cuowuspan.pass }}</div>
              </el-form-item>
              <ul class="m-mim" :class="{ mobile_flag: mobile_flag }">
                <li>
                  <span :class="{ curr: /\d/.test(shuru.pass) }">●</span>密码中包含数字
                </li>
                <li>
                  <span :class="{ curr: /[a-zA-Z]/g.test(shuru.pass) }">●</span>密码中包含字母
                </li>
                <li>
                  <span
                    :class="{
                      curr:
                        this.shuru.pass.length >= 8 &&
                        this.shuru.pass.length <= 25,
                    }"
                  >●</span>8-25位密码且没有特殊字符
                </li>
              </ul>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="确认新密码：">
                <el-input
                  placeholder="请再次确认您的密码"
                  @blur="passworda"
                  v-model="shuru.password"
                  show-password
                  maxlength="25"
                  minlength="8"
                ></el-input>
                <div class="el-form-item__error">{{ cuowuspan.password }}</div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col>
              <el-form-item>
                <div class="u-btton">
                  <el-button
                    type="warning"
                    round
                    @click="forget"
                    :class="[
                      shuru.phone != '' &&
                      shuru.Verification != '' &&
                      shuru.pass != '' &&
                      shuru.password != ''
                        ? 'xiugai'
                        : 'cao',
                    ]"
                    style="border-radius: 5px; border: none"
                  >&emsp;&emsp;&emsp;确认修改&emsp;&emsp;&emsp;</el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="removecompletely" @click="clickRemoveCompletely">注销账户(永久删除)</div>
    </div>
    <div class="Logout" v-show="RemoveCompletelyIshow">
      <p class="logout_text">
        <i style="color: #ffcc00">▎</i>账户注销
        <span class="logout_back" @click="backsecurity">返回</span>
      </p>

      <div class="loguot_phone">{{Logout_phone}}</div>
      <el-button class="logout_Verification" type="text" @click="open">注销账户</el-button>
      <div v-show="Logout_input" class="logout_input">
        <input
          type="text"
          class="logout_code"
          placeholder="请输入六位验证码"
          v-model="Logout_Verification"
          maxlength="6"
        />
        <button @click="ConfirmLogout">确认</button>
      </div>
      <div class="warning">请注意，如果注销账号，账号将永远无法恢复，请慎重使用！！！</div>
    </div>
  </div>
</template>

<script>
import adaption from '@/mixi/adaption'
export default {
  mixins: [adaption],
  metaInfo: {
    title: '云电脑_云游戏平台_畅玩3A游戏大作-海星云官网',
    meta: [{
      name: 'keywords',
      content: '修改海星云账号,修改密码,云游戏:海星云平台,海星云,云游戏,5G云游戏,海星云主机,海星云电脑,海星云2080ti,云平台,星瀛科技,星瀛云,4K高清游戏,手机玩电脑游戏,移动端steam,移动端3A,下载牛牛游戏,牛牛游戏下载,牛牛游戏大厅,网络游戏,好玩的游戏,权利的游戏,网易游戏'
    },
    {
      name: 'description',
      content: '作为硬核玩家与极客团队，创造了星瀛科技（北京）有限公司，融入5G时代新应用产业的发展，自主研发高性能“海星云”云游戏平台，提供软硬件综合解决方案，让伙伴们不再是云玩家，在任意时间、任意地点、任意设备，共享高画质流畅体验。未来，我们的征途是星辰大海，勇气与胸怀是我们踏上远方的陪伴，迈向星河彼岸，须弥胜境。-修改海星云账号,修改密码'
    }
    ]
  },
  data () {
    return {
      // 滑块参数
      nc_token: '',
      csessionid: '',
      sig: '',
      // 发送验证按按钮
      sendstime: 60,
      disabled: false,
      sends: '获取验证码',
      checked: false,
      // 输入的数据
      shuru: {
        phone: '',
        Verification: '',
        pass: '',
        password: ''
      },
      // 错误的提示信息
      cuowuspan: {
        phone: '',
        Verification: '',
        pass: '',
        password: ''
      },
      // 标识符
      phone: false,
      Verification: false,
      pass: false,
      password: false,

      // 注销账户显示隐藏
      RemoveCompletelyIshow: false,
      // 注销部分
      Logout_Verification: '',
      Logout_input: false,
      Logout_phone: '',
      token: ''
    }
  },
  created () {
    this.token = this.$cookieStore.getCookie('user_sess')
  },
  async mounted () {
    await this.http.getUserInfo({token: this.token, username: 'username'})
      .then(res => {
        console.log(res)
        if (res.data.code !== 200) {
          this.$message.info('获取个人信息请求失败')
          return false
        }
        this.Logout_phone = res.data.data.phone
      })
  },
  methods: {
    // 确认注销
    ConfirmLogout () {
      console.log(this.Logout_Verification)
      if (this.Logout_Verification && this.Logout_Verification.length === 6) {
        this.http.httpLogoutConfirmLogout(this.Logout_Verification).then(res => {
          console.log(res)
          if (res.data.code === 200) {
            setTimeout(() => {
              this.$cookieStore.delCookie('user_sess')
              this.$router.push('/Home')
            }, 2000)
            this.$message({
              type: 'success',
              message: '账号已注销'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.data.message2
            })
          }
        })
      } else {
        this.$message({
          type: 'info',
          message: '请输入六位验证码'
        })
      }
    },
    // 注销账户
    open () {
      this.$confirm('注销后无法恢复，请再次确认', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.http.logoutVerification(this.Logout_phone).then(res => {
          if (res.data.code === 200) {
            this.$message({
              type: 'success',
              message: '已发送验证码，请输入验证码进行下一步操作!'
            })
            this.Logout_input = true
          } else {
            this.$message({
              type: 'info',
              message: res.data.message
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消操作！'
        })
      })
    },
    backsecurity () {
      this.RemoveCompletelyIshow = false
    },
    clickRemoveCompletely () {
      this.RemoveCompletelyIshow = true
    },
    send () {
      this.nc_token = this.$cookieStore.getCookie('nc_token')
      this.csessionid = this.$cookieStore.getCookie('csessionid')
      this.sig = this.$cookieStore.getCookie('sig')
      if (this.shuru.phone == '') {
        this.cuowuspan.phone = '请填写手机号'
        this.phone = true
        return false
      } else {
        this.http.yzpho(this.shuru.phone).then(res => {
          if (res.data.code == 200) {
            if (res.data.message == 'false') {
              this.cuowuspan.phone = '该手机号没有注册，请注册！'
              this.phone = true
              return false
            }
          } else if (res.data.code == 500) {
            this.$notify({
              title: '请联系管理员咨询',
              type: 'warning'
            })
            return false
          }
          this.http
            .send(this.shuru.phone, this.nc_token, this.csessionid, this.sig)
            .then(res => {
              if (res.data.code == 200) {
                if (res.data.message == 'ok') {
                  this.$message({
                    message: '验证码已发送到您的手机，请注意查看',
                    type: 'success'
                  })
                  var that = this
                  var resend = setInterval(function () {
                    that.sendstime--
                    if (that.sendstime > 0) {
                      that.sends = that.sendstime + 's后重新获取'
                      that.disabled = true
                    } else {
                      clearInterval(resend)
                      that.sends = '获取验证码'
                      that.sendstime = 60
                      that.disabled = false
                    }
                  }, 1000)
                }
              } else if (res.data.code == 400) {
                if (res.data.message == 'failed,unable to get data') {
                  this.$message.error('不能获取到数据')
                } else if (res.data.message == 'failed,user phone invalid') {
                  this.$message.error('手机号无效')
                } else if (
                  res.data.message == 'failed,afs authenticate invalid'
                ) {
                  //  this.$message.error("滑块验证失败");
                }
              } else if (res.data.code == 500) {
                if (res.data.message == 'failed,please retry!') {
                  this.$message.error('验证码发送过于频繁，请稍后再试。，请重试！')
                }
              }
            })
        })
      }
    },
    forget () {
      if (
        this.shuru.phone == '' ||
                this.shuru.Verification == '' ||
                this.shuru.pass == '' ||
                this.shuru.password == ''
      ) {
        return
      }
      if (
        this.phone == true ||
                this.Verification == true ||
                this.pass == true ||
                this.password == true
      ) {
        return
      }
      this.http
        .xgpass(this.shuru.phone, this.shuru.Verification, this.shuru.pass)
        .then(res => {
          if (res.data.code == 200) {
            if (res.data.message == 'ok') {
              this.$message({
                message: '修改成功，快去登录吧！',
                type: 'success'
              })
              this.$cookieStore.delCookie('user_sess')
              this.$router.push('./SignIn')
            }
          }
        })
        .catch(err => {
          this.$message.error('修改密码失败')
        })
    },
    phonea () {
      if (this.shuru.phone == '') {
        this.phone = true
        this.cuowuspan.phone = '请填写手机号'
        return false
      } else if (this.shuru.phone) {
        var reg = /^1[2-9][0-9]\d{8}$/
        if (reg.test(this.shuru.phone)) {
          this.phone = false
          this.cuowuspan.phone = ''
        } else {
          this.phone = true
          this.cuowuspan.phone = '手机号格式有误'
          return false
        }
      }
    },
    Verificationa () {
      if (this.shuru.Verification == '') {
        this.cuowuspan.Verification = '请输入验证码'
        this.Verification = true
        return false
      } else if (this.shuru.Verification) {
        var reg = /^\d{6}$/
        if (reg.test(this.shuru.Verification)) {
          this.Verification = false
          this.cuowuspan.Verification = ''
        } else {
          this.Verification = true
          this.cuowuspan.Verification = '验证码格式有误'
          return false
        }
      }
    },
    passa () {
      if (this.shuru.password && this.shuru.password !== this.shuru.pass) {
        this.cuowuspan.pass = '两次密码输入不一致'
        this.pass = true
        return false
      }
      if (this.shuru.pass == '') {
        this.cuowuspan.pass = '请输入密码'
        this.pass = true
        return false
      } else if (this.shuru.pass) {
        if (this.shuru.pass.length >= 8 && this.shuru.pass.length <= 25) {
          this.cuowuspan.pass = ''
          this.pass = false
          this.cuowuspan.password = ''
          this.password = false
        } else {
          this.cuowuspan.pass = '密码格式有误'
          this.pass = true
          return false
        }
      }
    },
    passworda () {
      if (this.shuru.pass && this.shuru.pass !== this.shuru.password) {
        this.cuowuspan.password = '两次密码输入不一致'
        this.password = true
        return false
      }
      if (this.shuru.password == '') {
        this.cuowuspan.password = '请再次输入密码'
        this.password = true
        return false
      }
      if (this.shuru.password == this.shuru.pass) {
        this.cuowuspan.password = ''
        this.password = false
        this.cuowuspan.pass = ''
        this.pass = false
      }
    }
  },
  beforeDestroy () {
    this.$cookieStore.delCookie('nc_token')
    this.$cookieStore.delCookie('csessionid')
    this.$cookieStore.delCookie('sig')
  }
}
</script>

<style lang="scss" scoped>
.m-mim {
  span {
    color: #ff0000;
  }

  .curr {
    color: #00c802;
  }
}
.is-disabled {
  color: #ffffff8a;
  background: grey;
}
.yzmnew {
  color: #ffffff8a;
}
.xiugai {
  background: linear-gradient(90deg, #f3c304 0%, #ffe682 100%) !important;
  border-color: #f3c304;
  color: black;
}
.cao {
  background-color: grey;
  border-color: #ffffff8a !important;
}
.cao:hover {
  color: #ffffff8a;
}
.removecompletely {
  float: right;
  cursor: pointer;
  user-select: none;
}
.removecompletely:hover {
  color: #f4c91d;
}
.fater {
  position: relative;
}
.Logout {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #262f46;
  padding: 30px;
  z-index: 1000;
  // background-color: red;
}
.logout_back {
  float: right;
  background: linear-gradient(90deg, #f3c304, #ffe682);
  width: 100px;
  text-align: center;
  height: 34px;
  color: black;
  border-radius: 5px;
  line-height: 34px;
  cursor: pointer;
}
.logout_text {
  height: 34px;
}
.logout_Verification {
  width: 100px;
  text-align: center;
  height: 34px;
  background: linear-gradient(90deg, #f3c304, #ffe682);
  color: black;
  border-radius: 5px;
  float: right;
  cursor: pointer;
  margin-top: 25px;
  padding-top: 10px;
}
// .logout_Verification:hover {
//   color: black !important;
// }
.loguot_phone {
  height: 34px;
  line-height: 34px;
  float: left;
  margin-top: 25px;
  opacity: 0.6;
  cursor: no-drop;
  user-select: none;
}
.logout_input {
  margin-top: 90px;
}
.logout_input button {
  float: right;
  outline: none;
  border: none;
  background: linear-gradient(90deg, #f3c304, #ffe682);
  color: black;
  height: 34px;
  width: 100px;
  border-radius: 5px;
}
.logout_code {
  border: 5px;
  color: black;
  height: 34px;
  border-radius: 5px;
  text-indent: 15px;
}
.warning {
  position: absolute;
  right: 30px;
  bottom: 30px;
  color: red;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/security.vue